import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import { Paper, Container, Modal, IconButton } from "@mui/material";
import { Restore } from '@mui/icons-material';
import TableTitle from "../../../UI/MaterialTableOverrides/TableTitle";
import ModalPlaces from "../Modals/ModalPlaces";
import Map from '../../../components/Map/index';
import MapMarker from '../../../components/MapMarker/index';
import SiteSelector from "../../../UI/SiteSelector/SiteSelector";

const Maps = (props) => {
  const dispatch = useDispatch();
  let textInput = useRef(null);

  const [page, setPage] = useState(1);
  const [alreadySerched, setAlreadySerched] = useState(false);
  // const [searchText, setSearchText] = useState("");
  const [rootMarkers, setRootMarkers] = useState(true);  

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('root');
  const [modalEdit, setModalEdit] = useState(false);
  const [modalParent, setModalParent] = useState({});
  // center of the map
  const [latitudeCenter, setLatitudeCenter] = useState("");
  const [longitudeCenter, setLongitudeCenter] = useState("");
  const [zoomCenter, setZoomCenter] = useState(4);
  const [mapRef, setMapRef] = useState(null);

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);  
  const places = useSelector(state => state.places.placesRoots.rows);
  const placesLeafs = useSelector(state => state.places.placesLeafs.rows);
  const searchText = useSelector(state => state.places.searchText);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const mapConfig = useSelector(state => state.places.mapConfig);

  useEffect(() => {
    if (mapConfig.persisted) {
      setLatitudeCenter(mapConfig.latitude);
      setLongitudeCenter(mapConfig.longitude);
      setZoomCenter(mapConfig.zoom);
      setRootMarkers(mapConfig.rootMarkers);
    } else if (selectedAccess.tenant && selectedAccess.tenant.latitude && selectedAccess.tenant.longitude) {
      setLatitudeCenter(selectedAccess.tenant.latitude);
      setLongitudeCenter(selectedAccess.tenant.longitude);
      setZoomCenter(selectedAccess.tenant.zoom);
    }
  }, [selectedAccess]);

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])

  useEffect(() => {
    return () => (
      dispatch(actions.clearCopyPlace())
    )
  }, []);

  useEffect(() => {
    if (rootMarkers) {
      dispatch(actions.fetchPlacesRoots(selectedSites))
    }
  }, [selectedSites])

  useEffect(() => {
    if (searchText !== "" || alreadySerched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          dispatch(actions.fetchPlacesRoots(selectedSites));
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    } else {
      dispatch(actions.fetchPlacesRoots(selectedSites));
    }
  }, [searchText, textInput]);

  const setOpenModal = (open, type, edit, parent) => {
    setIsModalOpen(open);
    setModalType(type);
    setModalEdit(edit);
    setModalParent(parent)
  }

  const fitBounds = (map) => {
    const bounds = window.google && new window.google.maps.LatLngBounds();
    if (!rootMarkers && bounds) {
      placesLeafs
        .filter((place) => place.latitude && place.longitude)
        .forEach(({ latitude, longitude }) => {
          bounds.extend({ lat: parseFloat(latitude), lng: parseFloat(longitude) })
        });

      map.fitBounds(bounds);
    }
  };

  const loadHandler = (map) => {
    setMapRef(map);
    fitBounds(map);
  };

  const handleClick = (event, value) => {
    if (rootMarkers) {
      if (value.site) {
        const { latitude, longitude, site } = value;
        console.log('site from click: ', site);
        setRootMarkers(false);
        setZoomCenter(7);
        setLatitudeCenter(latitude);
        setLongitudeCenter(longitude);
        dispatch(actions.fetchPlacesLeafs([{ _id: site }]));
        dispatch(actions.setMapConfig({ 
          latitude,
          longitude,
          zoom: 4,
          site,
          persisted: true,
          rootMarkers: false,
        }));
      }
    } else {
      props.history.push(`admin-equip-places/${value._id}`);
    }
  };

  const handleMapClick = (e) => {
    console.log('lat: ', e.latLng.lat());
    console.log('lng: ', e.latLng.lng());
  };

  const handleBack = () => {
    if (selectedAccess.tenant && selectedAccess.tenant.latitude && selectedAccess.tenant.longitude) {
      const { latitude, longitude, zoom } = selectedAccess.tenant;
      setLatitudeCenter(selectedAccess.tenant.latitude);
      setLongitudeCenter(selectedAccess.tenant.longitude);
      setZoomCenter(selectedAccess.tenant.zoom);
      dispatch(actions.setMapConfig({ latitude, longitude, zoom, persisted: false, rootMarkers: true, site: null }));
    }
    setRootMarkers(true);
  };

  const selectSite = useCallback(
    (site) => dispatch(actions.selectSitePlaces(site))
  );

  useEffect (() => {
    if (!rootMarkers && placesLeafs.length > 0) fitBounds(mapRef);
  }, [placesLeafs]);

  return <>
    <Container maxWidth="xlg">
      <Paper>
        <div style={styles.tableTitleContainer}>
          <TableTitle title={i18n.t('tableTitleMap.title')} hideSearchInput />
          {!rootMarkers && <IconButton
            onClick={handleBack}
            style={styles.handleBackButtonContainer}
            size="large">
            <Restore style={styles.handleBackButton} />
          </IconButton>}
        </div>
        <div style={{ paddingLeft: 20 }}>
          <SiteSelector selectedSites={selectedSites} selectSite={(site) => selectSite(site)}/>
        </div>
        <Map
          onLoad={loadHandler}
          onClick={handleMapClick}
          height="75vh"
          zoom={zoomCenter}
          center={{ lat: latitudeCenter, lng: longitudeCenter }}
          items={
            rootMarkers ?
            places.map(place => <MapMarker key={place._id} title={place.name} handleClick={(e) => handleClick(e, place)} latitude={place.latitude} longitude={place.longitude} />):
            placesLeafs.map(place => <MapMarker key={place._id} title={place.name} handleClick={(e) => handleClick(e, place)} latitude={place.latitude} longitude={place.longitude} />)
          }
        />
      </Paper>
    </Container>
    <Modal
      open={isModalOpen}
      onClose={() => setOpenModal(false, '')}
      style={styles.modal}
    >
      <ModalPlaces
        type={modalType} //root or branch or leaf
        edit={modalEdit} //edit
        parent={modalParent}
        closeModal={setOpenModal}
      />
    </Modal>
  </>;
}

export default Maps;

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  treeContainer: {
    padding: 20,
    minHeight: 80,
  },
  tableTitleContainer: {
    position: 'relative',
  },
  handleBackButtonContainer: {
    position: 'absolute',
    right: 5,
    top: 5,
  },
  handleBackButton: {
    color: '#878787',
  },
}
